import React, { useState, useEffect, useCallback } from 'react';
import Banner from '../../ui/Banner';
import LiveChatWidget from '../chatWidget/LiveChatWidget';
import axios from '../../api/axios';
import './HelpCenter.css';
import FAQ_DATA from '../../data/FAQData.json';
import { Link } from 'react-router-dom';

const STATUS_CONFIG = {
  open: { label: 'Open', color: '#3b82f6', bg: '#eff6ff' },
  in_progress: { label: 'In Progress', color: '#f59e0b', bg: '#fffbeb' },
  resolved: { label: 'Resolved', color: '#10b981', bg: '#f0fdf4' },
  closed: { label: 'Closed', color: '#6b7280', bg: '#f9fafb' },
};

export default function HelpCenter() {
  const [openIndex, setOpenIndex] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const [myTickets, setMyTickets] = useState([]);
  const [ticketsLoading, setTicketsLoading] = useState(true);
  const contactEmail = process.env.REACT_APP_CONTACT_US || 'support@fpgtechnology.com';

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="hc-page">
      <Banner
        title="Help Center"
        subtitle="Find answers to common questions and get in touch with our team."
        type="page-header"
      />

      {/* FAQ Section */}
      <div className="hc-faq-section">
        <div className="hc-section-header">
          <i className="fas fa-circle-question" />
          <h2>Frequently Asked Questions</h2>
        </div>

        <div className="hc-faq-list">
          {FAQ_DATA.map((faq, index) => (
            <div key={index} className={`hc-faq-item ${openIndex === index ? 'open' : ''}`}>
              <button
                className="hc-faq-question"
                onClick={() => toggleFaq(index)}
                aria-expanded={openIndex === index}
              >
                <span className="hc-faq-num">{String(index + 1).padStart(2, '0')}</span>
                <span className="hc-faq-text">{faq.question}</span>
                <i
                  className={`fas fa-chevron-down hc-faq-chevron ${openIndex === index ? 'open' : ''}`}
                />
              </button>
              <div className={`hc-faq-answer ${openIndex === index ? 'open' : ''}`}>
                <p>{faq.answer}{' '}
                  {/* Show Additional Info if needed */}
                  {faq.showTermsAndPrivacy && (
                    <>
                      <br /> <br />
                      Click here to view our {' '}
                        <Link to="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link> and {' '}
                        <Link to="/terms" target="_blank" rel="noopener noreferrer">Terms and Conditions</Link>.
                    </>
                  )} 
                  {faq.showContactInfo && (
                    <>
                      <br /> <br />
                      If you need further assistance, please contact us at {' '}
                      <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                    </>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
